/**
 * Ensure calling constructor function with `new`.
 *
 * @param {Object} instance
 * @param {Function} ctor
 */
function classCallCheck(instance, ctor) {
  if (!(instance instanceof ctor)) {
    throw new Error(`Cannot call a class ${ctor.name} as a function`);
  }
}

export { classCallCheck };
